module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0019.jpg?v=28cb38e1";